import { render, staticRenderFns } from "./TopicOptions.vue?vue&type=template&id=42c19d46&scoped=true&"
import script from "./TopicOptions.vue?vue&type=script&lang=js&"
export * from "./TopicOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c19d46",
  null
  
)

export default component.exports